import React, { useState } from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import AddTestimonial from '../Components/Testimonial/AddTestimonial'
import { addDoc, collection } from 'firebase/firestore'
import { getDownloadURL } from 'firebase/storage'
import {
    ref as storageRef,
    uploadBytesResumable,
    listAll,
  } from "firebase/storage";
  import { ref, onValue, get,set,push,update} from "firebase/database";
import { db, storage } from '../firebase.config'
const Testimonial = () => {
    const [name, setName] = useState("")
    const [designation, setDesignation] = useState("")
    const [content, setContent] = useState("")
    const [video, setVideo] = useState("")
    const [videoThumbnail, setVideoThumbnail] = useState("")
    const addVideo = (e) =>{
    e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `testimonial/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
         setVideo(downloadURL)
        
       });
     }
   );
   }
   const addImage = (e) =>{
    e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `testimonial/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
         setVideoThumbnail(downloadURL)
        
       });
     }
   );
   }
    const addTestimonial = () =>{
        addDoc(collection(db, "testimonial"),{
       name: name,
       designation:designation,
       content:content,
       video:video,
       videoThumbnail:videoThumbnail
    })
    setName("")
    setDesignation("")
    setContent("")
    setVideo("")
    setVideoThumbnail("")
    
    }
  return (
    <div className='bg-gray-200' >
        <MultiLevelSidebar />
        <AddTestimonial name={name} setName={setName}
         designation={designation} setDesignation={setDesignation} 
         content={content} setContent={setContent}
         video={video} setVideo={setVideo}
         videoThumbnail={videoThumbnail} setVideoThumbnail={setVideoThumbnail}
         addTestimonial={addTestimonial}
         addImage={addImage} addVideo={addVideo}
          />
    </div>
  )
}

export default Testimonial